import React from "react";

const CartShimmer = ({ length = 3 }) => {
  return (
    <div>
      {Array.from({ length }).map((_, index) => (
        <div key={index} className="py-2 border-b animate-pulse">
          <div className="flex items-center justify-between px-2">
            <div className="flex items-center gap-2">
              {/* Image Placeholder */}
              <div className="w-[50px] h-[50px] bg-gray-300 rounded-md"></div>

              {/* Text Placeholder */}
              <div className="flex flex-col gap-1">
                <div className="w-28 h-4 bg-gray-300 rounded-md"></div>
                <div className="w-24 h-3 bg-gray-300 rounded-md"></div>
              </div>
            </div>

            {/* Close Icon Placeholder */}
            <div className="w-5 h-5 bg-gray-300 rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CartShimmer;
